<div class="sidebar-panel">
  <div id="scroll-area" [perfectScrollbar] class="navigation-hold" fxLayout="column">
    <div class="sidebar-hold">
      <!-- App Logo -->
      <div class="branding">
        <div class="logo-container">
          <img
            *ngIf="!(jwtAuth?.item?.empresaRemota !== undefined && jwtAuth?.item?.empresaRemota !== null) && (jwtAuth?.filial?.urlLogo === null)"
            src="assets/images/infokaw.png" alt="" class="app-logo">
          <img
            *ngIf="!(jwtAuth?.item?.empresaRemota !== undefined && jwtAuth?.item?.empresaRemota !== null) && jwtAuth?.filial?.urlLogo !== null"
            [src]="jwtAuth?.filial?.urlLogo" alt="" class="app-logo">
          <img *ngIf="jwtAuth?.item?.empresaRemota !== null" [src]="jwtAuth?.item?.empresaRemota?.urlLogo" alt=""
            class="app-logo">
          <span class="app-logo-text">
            {{(jwtAuth?.item?.empresaRemota !== undefined && jwtAuth?.item?.empresaRemota !== null
            ? jwtAuth?.item?.empresaRemota?.nomeFantasia : jwtAuth?.filial?.nomeFantasia) | slice:0:20}}
          </span>
        </div>
        <div class="sidebar-compact-switch" [ngClass]="{active: layoutConf.sidebarCompactToggle}"
          (click)="toggleCollapse()" *ngIf="layoutConf.sidebarStyle !== 'compact'">
          <span></span>
        </div>
      </div>

      <!-- Sidebar user -->
      <div class="app-user">
        <div *ngIf="this.showUpdate">
          <mat-card class="example-card" (click)="this.reloadApp()">
            <mat-card-header>
              <img mat-card-avatar src="assets/images/reload.png" alt="" style="max-width:48px;width:100%">
              <mat-card-title>Atualização disponível</mat-card-title>
            </mat-card-header>
            <mat-card-actions>
              <button mat-button (click)="this.reloadApp()">Clique para atualizar</button>
            </mat-card-actions>
          </mat-card>
        </div>
        <div class="app-user-photo">
          <img [appImageLoader]="this.jwtAuth.apiUrl + this.jwtAuth.path + '/image/profile'" alt=""
            class="mat-elevation-z1">
        </div>
        <span class="app-user-name mb-05">
          <mat-icon class="icon-xs text-muted">lock</mat-icon>
          {{jwtAuth?.user?.nome}}
        </span>
        <div class="app-user-controls">
          <button class="text-muted" mat-icon-button mat-xs-button [matMenuTriggerFor]="appUserMenu">
            <mat-icon>settings</mat-icon>
          </button>
          <button class="text-muted" mat-icon-button mat-xs-button matTooltip="{{'INBOX' | translate}}"
            routerLink="/inbox">
            <mat-icon>email</mat-icon>
          </button>
          <button class="text-muted" mat-icon-button mat-xs-button matTooltip="{{'SIGNOUT' | translate}}"
            routerLink="/sessions/signin">
            <mat-icon>exit_to_app</mat-icon>
          </button>
          <mat-menu #appUserMenu="matMenu">
            <button mat-menu-item routerLink="/profile/account">
              <mat-icon>account_box</mat-icon>
              <span>{{ "ACCOUNT" | translate }}</span>
            </button>
            <button mat-menu-item
              routerLink="/parametros/{{ jwtAuth?.item?.empresaRemota!== undefined && jwtAuth?.item?.empresaRemota !== null ? jwtAuth?.item?.empresaRemota?.filialApi:jwtAuth?.filial?.id}}">
              <mat-icon>settings_applications</mat-icon>
              <span>Parametros</span>
            </button>
            <button mat-menu-item
              routerLink="/filial/{{ jwtAuth?.item?.empresaRemota!== undefined && jwtAuth?.item?.empresaRemota !== null ? jwtAuth?.item?.empresaRemota?.filialApi:jwtAuth?.filial?.id}}">
              <mat-icon>edit</mat-icon>
              <span>Empresa</span>
            </button>
            <button mat-menu-item routerLink="/profile/transacao">
              <mat-icon>perm_data_setting</mat-icon>
              <span>{{ "TRANSACAO" | translate }}</span>
            </button>
            <button mat-menu-item [routerLink]="['/profile/filial']">
              <mat-icon>swap_vertical_circle</mat-icon>
              <span>{{ "ENTERPRISE" | translate }}</span>
            </button>
            <button mat-menu-item (click)="jwtAuth.signout()">
              <mat-icon>exit_to_app</mat-icon>
              <span>{{ "SIGNOUT" | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <!-- Navigation -->
      <app-sidenav [items]="menuItems" [hasIconMenu]="hasIconTypeMenuItem" [iconMenuTitle]="iconTypeMenuTitle">
      </app-sidenav>
    </div>
  </div>
</div>